import { render, staticRenderFns } from "./CatalogueList.vue?vue&type=template&id=f22ca8d4"
import script from "./CatalogueList.vue?vue&type=script&lang=js"
export * from "./CatalogueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports